import * as Sentry from '@sentry/react';
import { isProd } from '@ui/config/env';

const dsn = import.meta.env.REACT_APP_SENTRY_DSN;

if (isProd && dsn) {
    Sentry.init({
        dsn,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration(), Sentry.httpClientIntegration()],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['localhost', /^\/api/],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        sendDefaultPii: true,
    });
}
